<template>
  <CommonLayout header="floristHeader" footer="floristFooter" ref="commonRef">
    <MeetingLayout :type="this.consts.meetingType.florist">
      <b-overlay :show="overlayShow" rounded="sm">
        <div class="base-color overflow-auto mh-550 shadow">
          <form method="post" action="#" class="form-horizontal">
            <div class="col-sm-12 p-5 mt-3">
              <span class="text-break" v-if="mailAddressInMsg && !brideMailAddressInMsg" >ご入力いただいたメールアドレス（<span id="mailAddressInMsg">{{mailAddressInMsg}}</span>）にメールを
              送信いたしました。メールが届いているかご確認をお願いいたします。
              メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。</span>
              <span class="text-break" v-else-if="!mailAddressInMsg && brideMailAddressInMsg" >ご入力いただいたメールアドレス（<span id="brideMailAddressInMsg">{{brideMailAddressInMsg}}</span>）にメールを
              送信いたしました。メールが届いているかご確認をお願いいたします。
              メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。</span>
              <span class="text-break" v-else-if="mailAddressInMsg && brideMailAddressInMsg" >ご入力いただいたメールアドレス（<span id="mailAddressInMsg">{{mailAddressInMsg}}</span>, <span id="brideMailAddressInMsg">{{brideMailAddressInMsg}}</span>）にメールを
              送信いたしました。メールが届いているかご確認をお願いいたします。
              メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。</span>
            </div>
            <div class="col-sm-12">
              <div class="w-75 mt-5-auto">
                <b-button block variant="outline-secondary" class="sub-button-color white-btn-disabled" @click="showMailForm" :disabled="!isOperationPossible">メールアドレスを変更する場合</b-button>
              </div>
            </div>
            <transition>
              <div class="mail-send-form col-sm-12" v-show="isShowMailForm">
                <label for="mailAddress" class="control-label col-sm-12 mb-0">メールアドレス(1){{shinroShinpu1 !== 'shinro' ? '(ご新婦様)' : '(ご新郎様)'}}</label>
                <div class="input-group">
                  <input type="text" id="mailAddress" class="form-control input-sm send-mail-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('mailAddress')}" v-model="mailAddress" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                  <div class="invalid-feedback">{{ validation.firstError('mailAddress') }}</div>
                </div>
                <label for="brideMailAddress" class="control-label col-sm-12 mb-0 mt-2">メールアドレス(2){{shinroShinpu2 !== 'shinpu' ? '(ご新郎様)' : '(ご新婦様)'}}</label>
                <div class="input-group">
                  <input type="text" id="brideMailAddress" class="form-control input-sm send-mail-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('brideMailAddress')}" v-model="brideMailAddress" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                  <div class="invalid-feedback">{{ validation.firstError('brideMailAddress') }}</div>
                </div>
                <div class="input-group-btn text-right">
                  <b-button variant="outline-secondary" class="sub-button-color pl-4 pr-4 white-btn-disabled mt-3" @click="sendMail" :disabled="!isOperationPossible">送信</b-button>
                </div>
              </div>
            </transition>
            <div class="mb-2 mr-5 text-right position-absolute bottom-local">
              <!--<b-button variant="outline-secondary" class="w-25 sub-button-color" @click="backPage" id="back">戻る</b-button>-->
              <b-button variant="primary" class="w-25 ml-3 main-button-color blue-btn-disabled" @click="nextPage" id="next" :disabled="!isOperationPossible">次へ</b-button>
            </div>
          </form>
        </div>
      </b-overlay>
    </MeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<style scoped type="text/css">
.v-enter-active, .v-leave-active {
  transition: opacity .3s
}
.v-enter, .v-leave-to {
  opacity: 0
}
.form-control:read-only {
  background-color: #fff;
}
</style>
<script>
import Vue from 'vue'
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import MeetingLayout from '@/layout/MeetingLayout'
import fstore from '@/store/florist-store'
import SimpleVueValidation from 'simple-vue-validator'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import CustomerUpdateModel from '@/models/CustomerUpdateModel'
const Validator = SimpleVueValidation.Validator

Vue.use(SimpleVueValidation)

export default {
  name: 'FloristMeetingSendMail',
  components: { CommonLayout, CommonModal, MeetingLayout },
  data () {
    return {
      isShowMailForm: false,
      overlayShow: false,
      mailAddress: '',
      brideMailAddress: '',
      mailAddressInMsg: '',
      brideMailAddressInMsg: '',
      isOperationPossible: false,
      shinroShinpu1: '',
      shinroShinpu2: ''
    }
  },
  computed: {
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    },
    getIsOperationPossible () {
      return fstore.getters.isOperationPossible
    }
  },
  validators: {
    mailAddress: function (value) {
      if (this.brideMailAddress.trim()) {
        return Validator
          .value(value)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      } else {
        return Validator
          .value(value)
          .required(this.consts.validationMsg.meetingInput.mailAddress.required)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      }
    },
    brideMailAddress: function (value) {
      if (this.mailAddress.trim()) {
        return Validator
          .value(value)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      } else {
        return Validator
          .value(value)
          .required(this.consts.validationMsg.meetingInput.mailAddress.required)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      }
    }
  },
  watch: {
    getSignalingData (newData, oldData) {
      try {
        console.log('=== getSignalingData 開始 ===')
        console.log('newData ↓')
        console.log(newData)
        console.log('oldData ↓')
        console.log(oldData)
        newData['user'] = 'florist'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })
        if (newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('customer', 'florist')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (!fstore.getters.isOperationPossible) {
          if (newData['event'] === 'click' && newData['id'] === 'sendMail') {
            this.signalSendMail()
          }

          if (newData['event'] === 'input') {
            for (var i = 0; i < newData['data'].length; i++) {
              if (newData['data'][i] && newData['data'][i].id) {
                let elm = document.getElementById(newData['data'][i].id)
                if (newData['data'][i].id === 'isShowMailForm') {
                  this.isShowMailForm = newData['data'][i].value
                } else if (newData['data'][i].target) {
                  elm.value = newData['data'][i].value
                  elm.dispatchEvent(new Event('input'))
                  // customer側で変更した値に対してvalidationを実行するためにchangeイベントを発火する
                  elm.dispatchEvent(new Event('change'))
                } else {
                  elm.value = newData['data'][i].value
                  elm.dispatchEvent(new Event('input'))
                  elm.dispatchEvent(new Event('change'))
                }
              }
            }
          }
        }

        if (newData['event'] === 'text') {
          let elm = document.getElementById(newData['id'])
          elm.textContent = newData['data']
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    getIsOperationPossible: function (bool) {
      if (bool) {
        this.isOperationPossible = true
      } else {
        this.isOperationPossible = false
      }
    }
  },
  methods: {
    showMailForm () {
      try {
        this.isShowMailForm = !this.isShowMailForm
        this.sendSignalingInputData()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendSignalingInputData: function (e) {
      try {
        if (typeof e !== 'undefined' && e.type === 'blur') {
          this.$validate(e.target.id)
        }
        const inputs = document.querySelectorAll('.send-mail-input')
        let sendData = []
        for (var i = 0; i < inputs.length; i++) {
          if (typeof e !== 'undefined' && inputs[i].id === e.target.id) {
            sendData[i] = {'target': e.target.id, 'id': inputs[i].id, 'value': inputs[i].value}
          } else {
            sendData[i] = {'id': inputs[i].id, 'value': inputs[i].value}
          }
        }
        sendData.push({'id': 'isShowMailForm', 'value': this.isShowMailForm})
        sendData = sendData.filter(data => data.id !== '')
        SignalingModel.sendInputEvent(this, sendData)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    nextPage () {
      try {
        const targetPath = '/florist/meeting/hearing'
        SignalingModel.sendClickEvent('next', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    backPage () {
      try {
        const targetPath = '/florist/meeting/confirm'
        SignalingModel.sendClickEvent('back', this, {'target_path': targetPath.replace('florist', 'customer')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendMail: async function () {
      try {
        // cookieの打合せIDが変化しているかチェック
        let cookieProjectNumberCheckResult = await this.$refs.commonRef.cookieProjectNumberCheck()
        if (!cookieProjectNumberCheckResult) {
          this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.otherCookieProjectNumber)
          return
        }
        if (this.isOperationPossible) {
          let isError = await this.$validate()
            .then((success) => {
              return !success
            })

          SignalingModel.sendClickEvent('sendMail', this)

          if (isError) {
            return false
          }
          // 空白文字のみの入力の可能性がある為、メールアドレスの空白文字を削除する
          this.mailAddress = this.mailAddress.trim()
          this.brideMailAddress = this.brideMailAddress.trim()

          this.overlayShow = true
          const params = {
            'mailAddress': this.mailAddress,
            'brideMailAddress': this.brideMailAddress
          }
          await CustomerUpdateModel.apiSetStore(this.$bvModal, params, () => {
            this.overlayShow = false
          })
          this.mailAddressInMsg = this.mailAddress
          this.brideMailAddressInMsg = this.brideMailAddress
          this.$refs.commonModal.msgBoxOk('メールを送信しました')
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    signalSendMail: async function () {
      try {
        if (!this.isOperationPossible) {
          let isError = await this.$validate()
            .then((success) => {
              return !success
            })

          if (isError) {
            return false
          }
          // 空白文字のみの入力の可能性がある為、メールアドレスの空白文字を削除する
          this.mailAddress = this.mailAddress.trim()
          this.brideMailAddress = this.brideMailAddress.trim()

          this.mailAddressInMsg = this.mailAddress
          this.brideMailAddressInMsg = this.brideMailAddress
          this.$refs.commonModal.msgBoxOk('メールを送信しました')
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    loadValidate: async function (e) {
      try {
        if (typeof e !== 'undefined') {
          this.$validate(e.target.id)
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  created: function () {
    try {
      this.shinroShinpu1 = fstore.getters.shinroShinpu1
      this.shinroShinpu2 = fstore.getters.shinroShinpu2
      if (fstore.getters.mailAddress) {
        this.mailAddressInMsg = fstore.getters.mailAddress.trim()
        this.mailAddress = fstore.getters.mailAddress.trim()
      }
      if (fstore.getters.brideMailAddress) {
        this.brideMailAddressInMsg = fstore.getters.brideMailAddress.trim()
        this.brideMailAddress = fstore.getters.brideMailAddress.trim()
      }
      if (fstore.getters.shinroShinpu1 === 'shinpu' && fstore.getters.shinroShinpu2 === 'shinro') {
        [this.mailAddressInMsg, this.brideMailAddressInMsg, this.mailAddress, this.brideMailAddress] = [this.brideMailAddressInMsg, this.mailAddressInMsg, this.brideMailAddress, this.mailAddress]
        this.shinroShinpu1 = 'shinro'
        this.shinroShinpu2 = 'shinpu'
      }
      this.isOperationPossible = true
      fstore.commit('setIsOperationPossible', this.isOperationPossible)
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  }
}
</script>
<style scoped type="text/css">
  .blue-btn-disabled:disabled {
    background-color: rgb(0, 123, 255);
    color: #fff;
    opacity: 1;
  }
  .white-btn-disabled:disabled {
    color: rgb(0, 123, 255);
    border-color: rgb(0, 123, 255);
    background-color: #fff;
    opacity: 1;
  }
  .form-control:disabled {
    background-color: #fff;
  }
  input[type=radio] {
    transform: scale(2);
  }
  .bottom-local {
    right: 0;
    left: 0;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/FloristMeetingSendMail.vue